'use client';
import React from 'react';
import { Calendar, Star } from 'lucide-react';

const auspiciousDates = [
  { date: 'Mar 21', name: 'Ugadi', desc: 'Telugu & Kannada New Year', type: 'major' },
  { date: 'Mar 25', name: 'Gudi Padwa', desc: 'Marathi New Year', type: 'major' },
  { date: 'Mar 28', name: 'Ram Navami', desc: 'Birth of Lord Rama', type: 'major' },
  { date: 'Apr 6', name: 'Hanuman Jayanti', desc: 'Auspicious for Hanuman Pooja', type: 'auspicious' },
  { date: 'Apr 14', name: 'Tamil New Year', desc: 'Puthandu Celebrations', type: 'major' },
  { date: 'Apr 17', name: 'Akshaya Tritiya', desc: 'Most auspicious day of year', type: 'special' },
  { date: 'May 2', name: 'Narasimha Jayanti', desc: 'Ideal for Vishnu Pooja', type: 'auspicious' },
];

const typeColors: Record<string, string> = {
  major: 'bg-saffron/20 text-saffron border-saffron/30',
  auspicious: 'bg-gold/20 text-gold border-gold/30',
  special: 'bg-maroon/20 text-maroon border-maroon/30',
};

export default function AuspiciousStrip() {
  return (
    <section className="bg-white border-y border-gold/20 py-4 overflow-hidden">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0 flex items-center gap-2 text-maroon">
            <Calendar size={16} className="text-saffron" />
            <span className="text-xs font-semibold uppercase tracking-wider text-maroon/70 hidden sm:block">
              Auspicious Dates
            </span>
          </div>
          <div className="flex-1 overflow-x-auto scrollbar-hide">
            <div className="flex gap-3 pb-1" style={{ minWidth: 'max-content' }}>
              {auspiciousDates.map((item, i) => (
                <button
                  key={i}
                  className={`flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-medium transition-all hover:scale-105 whitespace-nowrap ${typeColors[item.type]}`}
                >
                  <span className="font-semibold">{item.date}</span>
                  <span>·</span>
                  <span>{item.name}</span>
                </button>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0 hidden md:flex items-center gap-1 text-gold text-xs font-medium">
            <Star size={13} fill="#D4AF37" />
            <span>Book early</span>
          </div>
        </div>
      </div>
    </section>
  );
}